<template>
  <div>
    <logged-in-header />
    <purchases-invoices-panel />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import purchasesInvoicesPanel from "../components/purchases-invoices/PurchasesInvoicesPanel";

export default {
  components: {
    loggedInHeader,
    purchasesInvoicesPanel
  }
};
</script>
